import { Plus, Video } from 'lucide-react';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { cn } from '@/lib/utils';

interface StoryBadgeProps {
  label: string;
  imageSrc: string;
  fallbackText: string;
  borderClassName: string;
  hasPlus?: boolean;
  isVideo?: boolean;
  onClick: () => void;
}

export function StoryBadge({
  label,
  imageSrc,
  fallbackText,
  borderClassName,
  hasPlus = false,
  isVideo = false,
  onClick,
}: StoryBadgeProps) {
  return (
    <button
      type="button"
      className="flex flex-shrink-0 flex-col items-center gap-2 text-[color:var(--jr-text)] transition-transform hover:-translate-y-0.5"
      onClick={onClick}
      aria-label={label}
    >
      <div className="relative flex h-20 w-20 items-center justify-center rounded-full bg-[color:rgba(49,31,29,0.92)] p-0.5 shadow-[0_10px_22px_rgba(0,0,0,0.22)] md:h-24 md:w-24">
        <Avatar
          className={cn(
            'h-full w-full rounded-full border-2 bg-[color:var(--jr-surface)]',
            borderClassName
          )}
        >
          <AvatarImage src={imageSrc} alt={label} className="object-cover" />
          <AvatarFallback className="bg-[color:var(--jr-surface-muted)] text-base font-medium text-[color:var(--jr-accent)]">
            {fallbackText}
          </AvatarFallback>
        </Avatar>
        {isVideo && (
          <div className="absolute bottom-0 left-0 flex h-5 w-5 items-center justify-center rounded-full border border-[color:var(--jr-border-strong)] bg-[color:rgba(35,23,22,0.96)] text-[color:var(--jr-accent)]">
            <Video className="h-2.5 w-2.5" />
          </div>
        )}
        {hasPlus && (
          <div className="absolute -bottom-1 -right-1 flex h-6 w-6 items-center justify-center rounded-full border-2 border-[color:rgba(35,23,22,0.96)] bg-[color:var(--jr-accent-strong)]">
            <Plus className="h-3.5 w-3.5 text-[color:#241514]" strokeWidth={3} />
          </div>
        )}
      </div>
      <span className="max-w-24 truncate text-center text-xs font-medium text-[color:var(--jr-text-soft)]">
        {label}
      </span>
    </button>
  );
}
